import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn, In} from "typeorm";
import { UserEntity } from "../user/user.entity";
@Entity('notifications')
export class NotificationsEntity{

    @PrimaryGeneratedColumn("increment",{name:'id'})
    Id:number;
    @Column("varchar",{
        nullable:false,
        length:500,
        name:"title"
    })
    title:string;
    @Column("varchar",{
        nullable:false,
        length:500,
        name:"message"
    })
    message:string;
    @Column("int",{
        nullable:false,
        name:"type_id"
    })
    typeId:number;
    @Column("int",{
        nullable:false,
        name:"user_id"
    })
    userId:number;
    @Column("int",{
        nullable:true,
        name:"target_id"
    })
    targetId:number;
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"status"
    })
    status:boolean;
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt:Date ;
    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
    @ManyToOne(() => UserEntity, (user:UserEntity) => user.notify)
    @JoinColumn({name:'user_id'})
    user:UserEntity;
}


